"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@emotion/react");
var themes_1 = require("./themes");
var StoryThemeWrapper = function (_a) {
    var children = _a.children, themeType = _a.themeType, _b = _a.fontSizeMultiplier, fontSizeMultiplier = _b === void 0 ? 1 : _b;
    var theme = (0, themes_1.getThemeWithFontMultiplier)(themeType, fontSizeMultiplier);
    return (0, jsx_runtime_1.jsx)(react_1.ThemeProvider, { theme: theme, children: children });
};
exports.default = StoryThemeWrapper;
//# sourceMappingURL=StoryThemeWrapper.js.map